import * as React from 'react';
import { Field } from 'redux-form';

import { bemElement } from 'af-utils/bem.util';

import Url from 'af-fields/Url';

interface OwnProps {
	fieldName: string;
}

type Props = OwnProps;

const ImmutableUrlField: React.FC<Props> = (props) => {
	const { fieldName } = props;

	const className = bemElement('report-block', 'immutable_link_field');

	return (
		<Field
			className={className}
			component={Url}
			name={fieldName}
		/>
	);
};

export default React.memo(ImmutableUrlField);
